import type { ICheckABState } from 'reactApp/modules/checkAB/checkAB.types';
import type { RootState } from 'reactApp/store';

const getCheckABState = (state: RootState): ICheckABState => state.checkAB;

export const getCheckABStatus = (state: RootState) => getCheckABState(state).isCheckAB;
